import { render, staticRenderFns } from "./AstrictMask.vue?vue&type=template&id=843b326a&scoped=true&"
import script from "./AstrictMask.vue?vue&type=script&lang=js&"
export * from "./AstrictMask.vue?vue&type=script&lang=js&"
import style0 from "./AstrictMask.vue?vue&type=style&index=0&id=843b326a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843b326a",
  null
  
)

export default component.exports